import { apiRequest } from './apiService';

const toCount = (value) => {
  const count = Number(value);
  return Number.isFinite(count) && count > 0 ? Math.trunc(count) : 0;
};

const normalizeActivity = (activity = {}) => ({
  conversations: toCount(activity.conversations),
  purchases: toCount(activity.purchases),
  totalSpentPence: toCount(activity.totalSpentPence),
  lastActiveAt: activity.lastActiveAt || null,
});

const normalizeConversation = (conversation = {}) => ({
  id: conversation.id || '',
  artistUid: conversation.artistUid || '',
  artistName: conversation.artistName || 'Artist',
  artworkId: conversation.artworkId || '',
  artworkTitle: conversation.artworkTitle || 'Artwork enquiry',
  status: conversation.status || 'open',
  createdAt: conversation.createdAt || null,
  updatedAt: conversation.updatedAt || null,
  lastMessageAt: conversation.lastMessageAt || null,
});

const normalizeOrder = (order = {}) => ({
  id: order.id || '',
  artworkId: order.artworkId || '',
  artworkTitle: order.artworkTitle || 'Artwork',
  artistUid: order.artistUid || '',
  status: order.status || '',
  fulfilmentMethod: order.fulfilmentMethod || '',
  currency: order.currency || 'gbp',
  totalPence: toCount(order.totalPence),
  createdAt: order.createdAt || null,
  updatedAt: order.updatedAt || null,
});

export const normalizeCollector = (data = {}) => ({
  id: data.id || data.uid || '',
  uid: data.uid || data.user_id || data.id || '',
  displayName:
    data.displayName ||
    data.user_display_name ||
    data.collectorDisplayName ||
    'Unknown collector',
  email: data.email || data.user_email || '',
  country: data.country || '',
  bio: data.bio || '',
  profileImage: data.profileImage || '',
  role: data.role || 'collector',
  approved: data.approved === true,
  identityVerified:
    data.identityVerified === true || data.identityVerificationStatus === 'verified',
  identityVerificationRequested: data.identityVerificationRequested === true,
  identityVerificationStatus:
    data.identityVerified === true
      ? 'verified'
      : data.identityVerificationStatus || 'not_started',
  identityVerificationRequestedAt: data.identityVerificationRequestedAt || null,
  identityVerifiedAt: data.identityVerifiedAt || null,
  submittedAt: data.submittedAt || null,
  createdAt: data.createdAt || data.submittedAt || null,
  updatedAt: data.updatedAt || null,
  activity: normalizeActivity(data.activity),
  recentConversations: Array.isArray(data.recentConversations)
    ? data.recentConversations.map(normalizeConversation)
    : [],
  recentOrders: Array.isArray(data.recentOrders)
    ? data.recentOrders.map(normalizeOrder)
    : [],
});

export const fetchCollectors = async () => {
  try {
    const collectors = await apiRequest('/admin/collectors') || [];
    return collectors.map(normalizeCollector);
  } catch (error) {
    console.error('Failed to fetch collectors:', error);
    throw new Error(error.message || 'Unable to load collectors');
  }
};

export const fetchCollectorById = async (collectorId) => {
  if (!collectorId) {
    throw new Error('Collector ID is required');
  }

  try {
    const collector = await apiRequest(`/admin/collectors/${encodeURIComponent(collectorId)}`);
    return normalizeCollector(collector);
  } catch (error) {
    console.error(`Failed to fetch collector ${collectorId}:`, error);
    throw new Error(error.message || 'Unable to load collector details');
  }
};
